import React from 'react'

export default function ProjectsFilterSearch ({placeholder, value, onChange}) {
  return (
    <input className={'mt-projects-archive__filter-container--search'} type="search" placeholder={placeholder} value={value} onChange={(e) => onChange(e.target.value)}/>
  )
}
